import React, { useEffect, useState } from "react";
import { setWorkbookProperty } from "./WorkbookSlice";
import { useDispatch } from "react-redux";
import { useDrag } from "react-dnd";
import { RiCalendarScheduleLine } from "react-icons/ri";
import { VscTypeHierarchySub } from "react-icons/vsc";
import { Dropdown, DropdownItem } from "flowbite-react";
import { PiDotsSixVertical } from "react-icons/pi";
import { RxComponentBoolean } from "react-icons/rx";
import { handleUpdateWorkbook } from "./components/WorkbookComponets/HandleUpdateWorkbook";
import { Tooltip } from "flowbite-react";

export default function ColumnData({
  data,
  index,
  setCalculatedUUID,
  setHeirarchyUUID,
  calculatedFields,
  hierarchy,
  updateWorkbook,
}) {
  // // console.log(data);
  const { dataType, rename, columnType, uuid } = data;
  const dispatch = useDispatch();
  const [{ isDragging }, drag] = useDrag({
    type: "Data",
    item: {
      _id: data._id,
      rename: rename,
      uuid: data.uuid,
      dataType: dataType,
      columnName: data.columnName || rename,
      columnType,
    },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  function displayContent() {
    let displayContent;
    switch (dataType) {
      case "String":
        displayContent = <span className=" text-blue-950">abc</span>;
        break;
      case "Number":
        displayContent = <span className="text-[rgb(90,193,137)]">#</span>;
        break;
      case "Date":
        displayContent = <RiCalendarScheduleLine className=" text-blue-950" />;
        break;
      case "Hierarchy":
        displayContent = <VscTypeHierarchySub className=" text-blue-950" />;
        break;
      case "Boolean":
        displayContent = <RxComponentBoolean className=" text-blue-950" />;
        break;
      default:
        displayContent = "";
    }
    return displayContent;
  }
  const handleEditClick = ({ columnType, uuid }) => {
    // console.log(columnType);
    if (columnType === "calculatedField") {
      setCalculatedUUID(uuid);
    } else if (columnType === "hierarchy") {
      setHeirarchyUUID(uuid);
    } else {
      console.error("columnType is undefined");
    }
  };

  const handleDeleteColumn = (data) => {
    // console.log(data.columnType);
    if (["calculatedField", "hierarchy"].includes(data.columnType)) {
      let updatedArray = [];
      if (data.columnType === "calculatedField") {
        updatedArray = calculatedFields.filter(
          (cItem) => cItem.uuid !== data.uuid
        );
      }
      if (data.columnType === "hierarchy") {
        updatedArray = hierarchy.filter(
          (cItem) => cItem["hierarchyColumn"].uuid !== data.uuid
        );
      }
      // console.log(updatedArray);
      dispatch(
        setWorkbookProperty({
          itemInArray: false,
          key:
            data.columnType === "calculatedField"
              ? "calculatedFields"
              : "hierarchy",
          value: updatedArray,
        })
      );
      handleUpdateWorkbook(updateWorkbook);
    } else {
      console.error("columnType is undefined");
    }
  };

  return (
    <div
      key={index}
      className="flex px-2 items-center justify-between w-full bg-gray-200 rounded relative"
      style={{ opacity: isDragging ? 0.5 : 1, cursor: "move" }}
      ref={drag}
    >
      <button className="relative flex flex-col items-start justify-center font-light gap-2 w-full truncate">
        <span className="w-full flex items-center justify-start gap-2" title={rename}>
          {displayContent(dataType)}
          {rename}
        </span>
      </button>

      <Dropdown
        label={
          <PiDotsSixVertical className="cursor-pointer text-black font-bold" />
        }
        arrowIcon={false}
        className="w-auto flex flex-col items-center justify-start"
        placement="right-start"
      >
        {!["calculatedField", "hierarchy"].includes(data.columnType) ? (
          <span className="p-1 text-red-500">No Option Avaiable</span>
        ) : null}
        {["calculatedField", "hierarchy"].includes(data.columnType) ? (
          <DropdownItem
            onClick={() =>
              handleEditClick({ columnType: data.columnType, uuid })
            }
          >
            Edit
          </DropdownItem>
        ) : null}
        {["calculatedField", "hierarchy"].includes(data.columnType) ? (
          <DropdownItem onClick={() => handleDeleteColumn(data)}>
            Delete
          </DropdownItem>
        ) : null}
      </Dropdown>
    </div>
  );
}
